import { FC, useContext, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';

import { FormField, SearchInput } from '~/core/shared/components';
import { DocumentListContext } from '../application';

export const DocumentsSearchInput: FC = () => {
  const { filters, setFilter } = useContext(DocumentListContext);

  const form = useForm({
    defaultValues: { search: filters.search || '' },
  });

  const { handleSubmit } = form;

  const onSubmit = (values: any): void => {
    setFilter('search', values.search);
  };

  useEffect(() => {
    form.setValue('search', filters.search ?? '');
  }, [filters.search]);

  return (
    <FormProvider {...form}>
      <Box as="form" onSubmit={handleSubmit(onSubmit)}>
        <FormField
          borderRadius={0}
          boxSize={8}
          color="black"
          colorPalette="white"
          component={SearchInput}
          height={8}
          iconPosition="start"
          iconProps={{
            height: 8,
          }}
          minW="250px"
          name="search"
          variant="outline"
        />
      </Box>
    </FormProvider>
  );
};
